import { type FilterItemBase } from "../FilterFormBuilder/FilterFormBuilder";
import { FilterViewTypes } from "../../../enums/filterViewTypes";
import PacksFilters from "enums/licensing/PacksFilters";

export const getPacksFilters = (
  includePublisher: boolean = false,
  includePricingType: boolean = false,
): FilterItemBase<PacksFilters>[] => {
  let filters: FilterItemBase<PacksFilters>[] = [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: PacksFilters.DateCreated,
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: PacksFilters.DateModified,
    },
  ];

  if (includePublisher) {
    filters.push({
      type: FilterViewTypes.MultiSelect,
      label: "Publisher",
      propertyName: PacksFilters.Publishers,
      placeholder: "All Publishers",
    });
  }

  if (includePricingType) {
    filters.push({
      type: FilterViewTypes.MultiSelect,
      label: "Type",
      propertyName: PacksFilters.PricingType,
      placeholder: "All",
    });
  }

  return filters;
};
